export default __webpack_public_path__ + "download.e72e67bbf7b393300b83.png";